import axios from "axios";
import { IDM_SERVER_BASE_URL } from "../Constants";

export const API_URL = IDM_SERVER_BASE_URL + "/v2/api";

class CertStoreService {
    uploadCert = async (key, certValue) => {
        const iDMRequest = {
            Request: { CertValue: certValue }
        };
        const response = await axios.put(`${API_URL}/CertStore/${key}`, iDMRequest, {
            headers: {
                "Content-Type": "application/json",
            },
        }, { withCredentials: true });

        return response.data;
    };

    getCert = async (key) => {
        const response = await axios.get(`${API_URL}/CertStore/${key}`, {
            headers: {
                "Content-Type": "application/json",
            },
        }, { withCredentials: true });

        return response.data;
    };
}

export default new CertStoreService();
